module.exports = __webpack_public_path__ + "static/media/28.37aa569d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/28.jpg
// module id = 235
// module chunks = 0